
import { PROFILES } from 'CONST';

// archivo con los permisos de lectura/escritura

export const LINEA_CREDITO_WRITE = [
  PROFILES.ceo,
  PROFILES.administradorTI,
  PROFILES.comercialCredito,
  PROFILES.gerenteRiesgoCredito,
  PROFILES.analistaRiesgoCredito,
  PROFILES.externoAdministradorCorredorCredito,
  PROFILES.externoAdministradorAseguradoCredito,
];

export const LINEA_CREDITO_READ = [
  ...LINEA_CREDITO_WRITE,
  PROFILES.administrativoRiesgoCredito,
  PROFILES.externoAseguradoCreditoSoloVista,
];

